import { OfflineConstants } from './constants';
import { deleteStoreItem, getAllStoreItems, getStoreItem, getStoreKeys, putStoreItem } from './offlineApi';

export const getSettingsItem = async (key) => await getStoreItem(OfflineConstants.stores.settings.storeName, key);
export const getAllSettingsItems = async () => await getAllStoreItems(OfflineConstants.stores.settings.storeName);
export const putSettingsItem = async (storeItem, key) => await putStoreItem(OfflineConstants.stores.settings.storeName, storeItem, key);
export const deleteSettingsItem = async (key) => await deleteStoreItem(OfflineConstants.stores.settings.storeName, key);
export const getSettingsKeys = async () => await getStoreKeys(OfflineConstants.stores.settings.storeName);
